/**
 * Entry point for the React site chrome.
 *
 * Two independent roots — the header and the footer — mount into the shells
 * rendered by inc/react-chrome.php. Mounting replaces the server-rendered
 * fallback markup that exists for crawlers and no-JS visitors.
 */
import { mount } from './wp';
import Header from './Header';
import Footer from './Footer';

function boot() {
    const config = window.TSA_CHROME;

    if (!config) {
        return;
    }

    const header = document.getElementById('tsa-chrome-header');
    if (header) {
        mount(header, <Header config={config} />);
    }

    const footer = document.getElementById('tsa-chrome-footer');
    if (footer) {
        mount(footer, <Footer config={config} />);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}
